export const GET_FELLOWSHIP_DATA = "GET_FELLOWSHIP_DATA";
export const GET_FELLOWSHIP_DATA_SUCCESS = "GET_FELLOWSHIP_DATA_SUCCESS";
export const GET_FELLOWSHIP_DATA_FAIL = "GET_FELLOWSHIP_DATA_FAIL";

export function getFellowship() {
  return {
    type: GET_FELLOWSHIP_DATA
  }
}
